import { Component, OnInit } from '@angular/core';
import { ChartDataset } from 'chart.js';
import { GraficoServices } from 'src/app/services/grafico.service';
import { finalize } from 'rxjs/operators';

import { NgChartsModule } from 'ng2-charts';

@Component({
    selector: 'app-grafico',
    templateUrl: './grafico.component.html',
    styleUrls: ['./grafico.component.css'],
    imports: [NgChartsModule]
})
export class GraficoComponent implements OnInit {

  dadosCDI:any[] = [];
  dadosPoupanca:any[] = [];
  dadosVMP:any[] = [];
  datas:any[] = [];
  lineChartData : ChartDataset[] = [];
  lineChartLabels : string[] = [];
  lineChartOptions : any
  lineChartLegend : boolean = true;
  lineChartPlugins : any = [];
  lineChartType : string = "bar";
  classe12:string = "";
  classe24:string = "";
  classe36:string = "";
  dadosCarregados: boolean = false;


  constructor(private grafico:GraficoServices) { }

  ngOnInit() {
    this.buscaDados(12);
  }


  buscaDados(numMes){
    this.setaClasse(numMes)
    this.grafico
    .buscaDados(numMes)
    .subscribe(
      (res:any)=>{

        this.datas = res.listaDatas;
        this.dadosCDI = res.cdi;
        this.dadosPoupanca = res.poupanca;
        this.dadosVMP = res.vmp;

        this.acumular();

        this.montaGrafico();

        this.dadosCarregados = true;
      }
    )
  }


  acumular(){

    this.dadosVMP.push(this.calcTaxaAcumuladaArray(this.dadosVMP));
    this.dadosCDI.push(this.calcTaxaAcumuladaArray(this.dadosCDI));
    this.dadosPoupanca.push(this.calcTaxaAcumuladaArray(this.dadosPoupanca));

    this.datas.push('acumulado');
  }

  private calcTaxaAcumuladaArray(itens: any[]){

    var fatorAcum = 0;
    var acumulado=0;

    for (let i = 0; i < itens.length; i++) {

      let fator = 1 + (itens[i]/100);

      if(i==0){
        fatorAcum = fator;
      }else{
        fatorAcum = fator*fatorAcum;
      }
    }

    acumulado = (fatorAcum-1)*100;

    return acumulado.toFixed(2);
  }

  montaGrafico(){
    // Line Chart Start
  this.lineChartData  = [
    {
      label: 'CDI',
      backgroundColor: "#bfdb75",
      hoverBackgroundColor: "#bfdb75",
      data:  this.dadosCDI ,
      barThickness: 8,
      maxBarThickness: 14,
      minBarLength: 4,
    }, {
      label: 'Poupança',
      backgroundColor: "#a07690",
      hoverBackgroundColor: "#a07690",
      data: this.dadosPoupanca,
      barThickness: 8,
      maxBarThickness: 14,
      minBarLength: 4,
    }, {
      label: 'Viva Mais',
      backgroundColor: "#669ab2",
      hoverBackgroundColor: "#669ab2",
      data:this.dadosVMP,
      barThickness: 8,
      maxBarThickness: 14,
      minBarLength: 4,
    }
  ];

  this.lineChartLabels = this.datas;

  this.lineChartOptions = {
    tooltips: {
      mode: 'index',
      intersect: false,
      cornerRadius: 10,
      borderWidth: 0,
      callbacks: {
        label: function(tooltipItems, data) {
          let label = data.datasets[tooltipItems.datasetIndex].label
          label += ': '
          label += parseFloat(tooltipItems.yLabel.toString()).toFixed(2).replace(".",",") + '%';
          return label
        }
      }
    },
    legend: {
       display: false
    },
    responsive: true,
    scales: {
      xAxes: [
        {
          position: "bottom",
          ticks: {
            fontSize: 13,
            fontColor: "#005781",
            fontStyle: "700"
          },
          gridLines: {
            drawBorder: false,
            tickMarkLength: 25,
            zeroLineWidth: 0,
            borderDash: [3],
            color: "rgba(0,0,0,0.05)"
          }
        }
      ],
      yAxes: [{
        ticks: {
          fontSize: 13,
          fontColor: "#005781",
          fontStyle: "700",
          beginAtZero: true,
          callback: function(value, index, values) {
            return value + "%";
          }
        },
        gridLines: {
          drawBorder: false,
          tickMarkLength: 25,
          zeroLineWidth: 0,
          borderDash: [3],
          color: "rgba(0,0,0,0.05)"
        }
      }]
    }
  };

  this.lineChartLegend = true;
  this.lineChartPlugins = [];
  this.lineChartType = "bar";
  }

  setaClasse(numMes){
    if(numMes == 12){
      this.classe12 = "item active";
      this.classe24 = "item";
      this.classe36 = "item";
    }else if(numMes == 24){
      this.classe12 = "item";
      this.classe24 = "item active";
      this.classe36 = "item";
    }else{
      this.classe12 = "item";
      this.classe24 = "item";
      this.classe36 = "item active";
    }
  }

}
